export default "__VITE_ASSET__CBxoLIxt__"